import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * ===============================
 * ADMIN ANNOUNCEMENTS SERVICE
 * ===============================
 */


/**
 * Get all announcements (admin view)
 */
export const fetchAllAnnouncements = async () => {
  try {

    const response = await api.get("/admin/announcements");

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch announcements",
    };

  }
};


/**
 * Create new announcement
 */
export const createAnnouncement = async (announcement) => {

  try {

    const response = await api.post(
      "/admin/announcements",
      announcement
    );

    return {
      status: response.status,
      data: response.data,
      message: "Announcement created successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to create announcement",
    };

  }

};


/**
 * Update announcement
 */
export const updateAnnouncement = async (id, announcement) => {

  try {

    const response = await api.put(
      `/admin/announcements/${id}`,
      announcement
    );

    return {
      status: response.status,
      data: response.data,
      message: "Announcement updated successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to update announcement",
    };

  }

};


/**
 * Enable / Disable announcement
 */
export const toggleAnnouncementStatus = async (id, enabled) => {

  try {

    const response = await api.patch(
      `/admin/announcements/${id}/enable`,
      null,
      {
        params: { enabled },
      }
    );

    return {
      status: response.status,
      data: response.data,
      message: enabled
        ? "Announcement enabled"
        : "Announcement disabled",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to update status",
    };

  }

};


/**
 * Delete announcement
 */
export const deleteAnnouncement = async (id) => {

  try {

    const response = await api.delete(
      `/admin/announcements/${id}`
    );

    return {
      status: response.status,
      message: "Announcement deleted successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to delete announcement",
    };

  }

};
